



















































import { Component, Vue, Watch } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import { UserModule } from "@/store/modules/user";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import Hamburger from "@/components/Hamburger/index.vue";

@Component({
  name: "Navbar",
  components: {
    Breadcrumb,
    Hamburger,
  },
})
export default class extends Vue {
  created() {}
  mounted() {
    this.name = window.sessionStorage.getItem("name");
    console.log(window.sessionStorage.getItem("name"));
    // 小铃铛动画效果
    // let propot: any = document.querySelector(".message");
    // this.messageBegin = setInterval(function () {
    //   propot.style.transform = this.isshake
    //     ? "rotatez(-6deg)"
    //     : "rotatez(6deg)";
    //   this.isshake = !this.isshake;
    // }, 100);
    // if (this.isdraw) {
    //   this.messageBegin;
    // }
  }
  private dialogVisible = false;
  private name: any = "";
  private isshake = true;
  private isdraw = true;
  private messageBegin;
  get sidebar() {
    return AppModule.sidebar;
  }

  get device() {
    return AppModule.device.toString();
  }

  get avatar() {
    return UserModule.avatar;
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }
  // 跳转到训练计划页面
  // private jumptrainplan() {
  //   clearInterval(this.messageBegin);
  //   let propot: any = document.querySelector(".message");
  //   propot.style.transform = "rotatez(0deg)";
  //   this.$router.push("/trainplanManage/trainplanManage");
  // }
  private async logout() {
    // await UserModule.LogOut();
    sessionStorage.clear();
    // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    this.$router.push(`/login`);
  }

  private changePsd() {
    this.dialogVisible = true;
  }
  private handleClose() {}
}
